// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0b140ed","308":"8c78ea78","430":"513aedf2","453":"016f414f","667":"54d378d3"}[chunkId] + ".chunk.js";
};